<template>
  <div class="table-column__list">
    <label class="table-text form__label m-0 mb-1 custom-label">Hidden members:</label>
    <multiselect
      style="width: 244px;"
      v-model="activeState"
      :options="membersList"
      track-by="name"
      label="name"
      :showLabels="false"
      multiple
      allow-empty
      ref="multiselect"
    >
      <template slot="option" slot-scope="props">
        <div
          class="option__desc"
          @click.stop="changeActive(props.option)"
        >
          {{ props.option.name }}
        </div>
      </template>
      <template slot="selection" slot-scope="{ values, isOpen }">
        <span
          class="multiselect__single"
          v-if="values.length && !isOpen"
        >
          {{ values.length }}/{{ membersList.length }}
        </span>
      </template>
      <template slot="tag">
        <i></i>
      </template>
    </multiselect>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    tableName: {
      type: String
    },
    membersList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      activeState: [],
      disabledUsers: []
    }
  },
  computed: {
    ...mapGetters({
      getTableHiddenColumnKeys: 'frontView/getTableHiddenColumnKeys'
    }),
    getDisabledUsers () {
      return this.activeState.map(user => user.id)
    }
  },
  mounted () {
    this.setActiveState(this.membersList)
    this.loadTableHiddenColumns(this.tableName)
      .then(response => {
        this.disabledUsers = this.getTableHiddenColumnKeys(this.tableName)
        this.setActiveState(this.membersList)
      })
      .catch(console.error)
      .finally(() => {
        this.isDataLoading = false
      })
  },
  methods: {
    ...mapActions({
      loadTableHiddenColumns: 'frontView/loadTableHiddenColumns',
      addHiddenColumnKey: 'frontView/addHiddenColumnKey',
      removeHiddenColumnKey: 'frontView/removeHiddenColumnKey'
    }),
    setActiveState (members) {
      const disabledId = this.disabledUsers.slice()
      for (const i in members) {
        if (disabledId.some(id => members[i].id === id)) {
          this.activeState.push(members[i])
        }
      }
      this.$emit('changeActive', this.disabledUsers)
      this.$forceUpdate()
    },
    changeActive (option) {
      this.$refs.multiselect.toggle()

      const indexItem = this.activeState.findIndex(user => user.id === option.id)

      if (indexItem !== -1) {
        this.activeState.splice(indexItem, 1)
        this.removeHiddenColumnKey({ tableName: this.tableName, key: option.id })
      } else {
        this.activeState.push(option)
        this.addHiddenColumnKey({ tableName: this.tableName, key: option.id })
      }

      this.$emit('changeActive', this.getDisabledUsers)
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
  .custom-label {
    color: $fontColor3;
    font-weight: 400;
  }
</style>
